import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing,
  text = theme.text;
export var list = /*#__PURE__*/css(["list-style-type:none;text-align:left;margin:0 0 ", " 0;padding:0;"], pxToRem(spacing.xxl));
export var item = /*#__PURE__*/css(["margin:", " 0;"], pxToRem(spacing.sm));
export var link = /*#__PURE__*/css(["", " color:var(--neutral-black-base);text-decoration:none;font-weight:normal;&:hover{color:var(--brand-purple-base);text-decoration:underline;}"], fontSize(text.BODY.SM));